import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("user"));

  // अगर login ही नहीं है
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // अगर role admin नहीं है
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // ✅ अगर admin है → allow access
  return children;
};

export default AdminRoute;